import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import SearchIcon from '@mui/icons-material/Search';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import {
  AppBar,
  Avatar,
  Box,
  Chip,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Stack,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';
import { HttpService } from 'core/services/http';
import React from 'react';
import { useThemeMode } from '../context/ThemeContext';

const AdminHeader = ({ onMenuClick, user, pageTitle, drawerWidth }) => {
  const { mode, toggleTheme } = useThemeMode();

  const handleLogout = () => {
    HttpService.clearToken?.();
    localStorage.clear();
    window.location.href = '/cms/login';
  };

  const initials = user?.first_name?.[0] ?? user?.email?.[0] ?? 'A';

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        width: { md: `calc(100% - ${drawerWidth ?? 0}px)` },
        ml: { md: `${drawerWidth ?? 0}px` }
      }}
    >
      <Toolbar sx={{ minHeight: '56px !important', px: { xs: 2, md: 3 } }}>
        <IconButton
          edge="start"
          color="inherit"
          sx={{ mr: 2, display: { md: 'none' } }}
          onClick={onMenuClick}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="subtitle1" fontWeight={650} color="text.primary">
          {pageTitle ?? 'Control Center'}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <OutlinedInput
          placeholder="Search in CMS"
          size="small"
          sx={{ display: { xs: 'none', sm: 'flex' }, mr: 2, width: 220, fontSize: '0.82rem' }}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          }
        />
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Chip label="Admin" color="primary" size="small" variant="outlined" sx={{ height: 22 }} />
          <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton size="small" color="inherit" onClick={toggleTheme}>
              {mode === 'dark' ? <Brightness7Icon fontSize="small" /> : <Brightness4Icon fontSize="small" />}
            </IconButton>
          </Tooltip>
          <IconButton size="small" color="inherit">
            <NotificationsNoneOutlinedIcon fontSize="small" />
          </IconButton>
          <Tooltip title="Sign out">
            <IconButton size="small" color="inherit" onClick={handleLogout}>
              <LogoutOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Avatar sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', width: 32, height: 32, fontSize: '0.85rem', fontWeight: 700 }}>{initials}</Avatar>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;